(function () {
  'use strict';

  if (window.NurayaTheme) return;

  var SELECTORS = {
    drawer: '#CartDrawer',
    drawerBody: '#CartDrawerBody',
    count: '[data-cart-count]',
    productForm: '#ProductForm',
    cartForm: '#cart_form',
    curation: '#nl-precheckout',
    curationGrid: '#nl-precheckout-grid'
  };

  var state = null;
  var serverQueue = Promise.resolve();
  var mutationVersion = 0;

  function escapeHtml(value) {
    var element = document.createElement('div');
    element.textContent = value || '';
    return element.innerHTML;
  }

  function activeCurrency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || (state && state.currency) || 'GBP';
  }

  function money(cents, currency) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || activeCurrency()
      }).format(amount);
    } catch (_) {
      return amount.toFixed(2) + ' ' + (currency || activeCurrency());
    }
  }

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function normaliseCart(cart) {
    cart = cart || {};
    cart.items = Array.isArray(cart.items) ? cart.items : [];
    cart.item_count = cart.items.reduce(function (total, item) {
      return total + Number(item.quantity || 0);
    }, 0);
    cart.total_price = Number.isFinite(cart.total_price) ? cart.total_price : cart.items.reduce(function (total, item) {
      return total + Number(item.final_line_price || (item.final_price || item.price || 0) * item.quantity || 0);
    }, 0);
    cart.currency = cart.currency || activeCurrency();
    return cart;
  }

  function initialCart() {
    var element = document.getElementById('NurayaInitialCart');
    if (!element) return null;
    try { return normaliseCart(JSON.parse(element.textContent || '{}')); } catch (_) { return null; }
  }

  function fetchCart() {
    return fetch(localePath('/cart.js'), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load bag');
      return response.json();
    }).then(normaliseCart);
  }

  function itemImage(item) {
    var image = item.image || item.featured_image || '';
    if (typeof image === 'object') image = image.src || image.url || '';
    return image;
  }


  // Locale-aware cart requests keep Shopify translations and market context.
  function localePath(path) {
    if (!path || path === '#') return path || '#';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || (/^\/ar(?:\/|$)/.test(location.pathname) ? '/ar/' : '/');
    return root.replace(/\/$/, '') + '/' + String(path || '').replace(/^\/(?:ar\/)?/, '');
  }
  function cartArabic() { return /^ar/i.test(document.documentElement.lang || ''); }
  function cartMarkup(html) {
    if (!cartArabic()) return html;
    return html.replace(/Your bag is empty\./g, 'حقيبتك فارغة.').replace(/CONTINUE SHOPPING/g, 'متابعة التسوق').replace(/CONTINUE/g, 'متابعة إتمام الطلب').replace(/Subtotal/g, 'المجموع الفرعي').replace(/>Product</g, '>المنتج<').replace(/>Price</g, '>السعر<').replace(/>Qty</g, '>الكمية<').replace(/>Total</g, '>الإجمالي<').replace(/Decrease quantity/g, 'تقليل الكمية').replace(/Increase quantity/g, 'زيادة الكمية').replace(/Quantity for /g, 'الكمية: ').replace(/Remove /g, 'إزالة ');
  }
  function cartVariant(value) {
    if (!cartArabic()) return value;
    var names = {Brown:'بني',Black:'أسود','Dark Brown':'بني داكن',Purple:'أرجواني',S:'صغير',M:'متوسط',L:'كبير',XL:'كبير جداً',XXL:'كبير جداً جداً'};
    return String(value || '').split(' / ').map(function (part) { return names[part] || part; }).join(' / ');
  }

  function itemUrl(item) {
    return localePath(item.url || (item.handle ? '/products/' + item.handle : '#'));
  }

  function renderCount(cart) {
    document.querySelectorAll(SELECTORS.count).forEach(function (element) {
      element.textContent = String(cart.item_count);
      element.hidden = cart.item_count < 1;
      element.setAttribute('aria-label', cart.item_count + (cart.item_count === 1 ? ' item in bag' : ' items in bag'));
    });
  }

  function drawerItem(item) {
    var variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<div class="nl-cart-item__variant">' + escapeHtml(cartVariant(item.variant_title)) + '</div>'
      : '';
    var image = itemImage(item);
    return '<article class="nl-cart-item" data-cart-key="' + escapeHtml(item.key) + '">' +
      '<a class="nl-cart-item__image" href="' + escapeHtml(itemUrl(item)) + '">' +
        (image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(item.product_title) + '" width="156" height="196">' : '') +
      '</a>' +
      '<div class="nl-cart-item__content">' +
        '<div class="nl-cart-item__top">' +
          '<a class="nl-cart-item__title" href="' + escapeHtml(itemUrl(item)) + '">' + escapeHtml(item.product_title) + '</a>' +
          '<button type="button" class="nl-cart-item__remove" data-nl-cart-remove="' + escapeHtml(item.key) + '" aria-label="Remove ' + escapeHtml(item.product_title) + '">×</button>' +
        '</div>' + variant +
        '<div class="nl-cart-item__bottom">' +
          '<div class="nl-cart-quantity" aria-label="Quantity for ' + escapeHtml(item.product_title) + '">' +
            '<button type="button" data-nl-cart-quantity="' + escapeHtml(item.key) + '" data-quantity="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
            '<span aria-live="polite">' + item.quantity + '</span>' +
            '<button type="button" data-nl-cart-quantity="' + escapeHtml(item.key) + '" data-quantity="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<strong>' + money(item.final_line_price, state.currency) + '</strong>' +
        '</div>' +
      '</div>' +
    '</article>';
  }

  function discountSummary(cart) {
    if(cart._pending)return '<p role="status">'+(cartArabic()?'جارٍ تحديث حقيبتك…':'Updating your bag…')+'</p>';
    var ar=cartArabic(),discounts=cart.cart_level_discount_applications||[],before=Number.isFinite(cart.items_subtotal_price)?cart.items_subtotal_price:cart.total_price;
    return '<div><span>'+(ar?'المجموع الفرعي':'Subtotal')+'</span><strong>'+money(before,cart.currency)+'</strong></div>'+discounts.map(function(d){return '<div class="basket-saving"><span>'+escapeHtml(ar?'هديتك':d.title)+'</span><strong>−'+money(d.total_allocated_amount,cart.currency)+'</strong></div>';}).join('')+'<div class="basket-total"><span>'+(ar?'الإجمالي':'Total')+'</span><strong>'+money(cart.total_price,cart.currency)+'</strong></div>'+(!discounts.length?'<p class="basket-gift-note">'+(ar?'هديتك: خصم 15٪ على طلبك الأول، ثم 10٪ على طلباتك التالية. استخدمي البريد الإلكتروني نفسه عند إتمام الشراء ليُطبّق خصمك المستحق تلقائياً.':'Your gift: 15% off your first order, then 10% on future orders. Use the same email at checkout and your eligible gift will be applied automatically.')+'</p>':'');
  }

  function renderDrawer(cart) {
    var body = document.querySelector(SELECTORS.drawerBody);
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="nl-cart-empty"><p>Your bag is empty.</p><a class="btn btn--primary" href="/collections/new-arrivals-1">CONTINUE SHOPPING</a></div>';
      body.innerHTML = cartMarkup(body.innerHTML);
      body.querySelectorAll('a[href^="/"]').forEach(function(a) { a.setAttribute('href', localePath(a.getAttribute('href'))); });
      return;
    }
    body.innerHTML = '<div class="nl-cart-items">' + cart.items.map(drawerItem).join('') + '</div>' +
      '<div class="nl-cart-summary">' + discountSummary(cart) +
      '<a href="/checkout" class="btn btn--primary">CONTINUE</a></div><div data-basket-upsell-slot></div>';
    body.innerHTML = cartMarkup(body.innerHTML);
    body.querySelectorAll('a[href^="/"]').forEach(function(a) { a.setAttribute('href', localePath(a.getAttribute('href'))); });
  }

  function renderCartPage(cart) {
    var form = document.querySelector(SELECTORS.cartForm);
    if (!form) return;
    if (!cart.items.length) {
      form.innerHTML = '<div class="cart-page__empty"><p>Your bag is empty.</p><a class="btn btn--primary" href="/collections/new-arrivals-1">CONTINUE SHOPPING</a></div>';
      return;
    }
    var rows = cart.items.map(function (item) {
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<span class="cart-page__variant">' + escapeHtml(cartVariant(item.variant_title)) + '</span>' : '';
      return '<tr data-cart-key="' + escapeHtml(item.key) + '">' +
        '<td class="cart-page__item"><img src="' + escapeHtml(itemImage(item)) + '" alt="' + escapeHtml(item.product_title) + '" width="160" height="200"><div><a href="' + escapeHtml(itemUrl(item)) + '">' + escapeHtml(item.product_title) + '</a>' + variant + '</div></td>' +
        '<td>' + money(item.final_price || item.price, cart.currency) + '</td>' +
        '<td><input type="number" min="0" inputmode="numeric" value="' + item.quantity + '" data-nl-cart-input="' + escapeHtml(item.key) + '" aria-label="Quantity for ' + escapeHtml(item.product_title) + '"></td>' +
        '<td>' + money(item.final_line_price, cart.currency) + '</td>' +
        '<td class="cart-page__remove-cell"><button type="button" class="cart-page__remove-btn" data-nl-cart-remove="' + escapeHtml(item.key) + '" aria-label="Remove ' + escapeHtml(item.product_title) + '">×</button></td>' +
      '</tr>';
    }).join('');
    form.innerHTML = '<table class="cart-page__table"><thead><tr><th>Product</th><th>Price</th><th>Qty</th><th>Total</th><th></th></tr></thead><tbody>' + rows + '</tbody></table>' +
      '<div class="cart-page__summary basket-page-summary">' + discountSummary(cart) + '</div>' +
      '<a href="/checkout" class="btn btn--primary">CONTINUE</a><div data-basket-upsell-slot></div>';
    form.innerHTML = cartMarkup(form.innerHTML);
    form.querySelectorAll('a[href^="/"]').forEach(function(a){a.setAttribute('href',localePath(a.getAttribute('href')));});
  }

  function renderAll(cart) {
    state = normaliseCart(cart);
    renderCount(state);
    renderDrawer(state);
    renderCartPage(state);
    updateCurationButtons();
    document.dispatchEvent(new CustomEvent('nuraya:cart:updated', { detail: { cart: clone(state) } }));
  }

  function openDrawer() {
    var drawer = document.querySelector(SELECTORS.drawer);
    if (!drawer) return;
    renderDrawer(state || normaliseCart({ items: [] }));
    drawer.setAttribute('aria-hidden', 'false');
    fetchCart().then(renderAll).catch(function(){});
  }

  function closeDrawer() {
    var drawer = document.querySelector(SELECTORS.drawer);
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  }

  function optimisticChange(key, quantity) {
    var next = clone(state);
    var item = next.items.find(function (line) { return line.key === key; });
    if (!item) return next;
    if (quantity <= 0) {
      next.items = next.items.filter(function (line) { return line.key !== key; });
    } else {
      item.quantity = quantity;
      item.final_line_price = Number(item.final_price || item.price || 0) * quantity;
      item.original_line_price = Number(item.original_price || item.price || 0) * quantity;
    }
    next._pending = true;
    delete next.total_price;
    delete next.total_discount;
    delete next.items_subtotal_price;
    delete next.cart_level_discount_applications;
    return normaliseCart(next);
  }

  function optimisticAdd(item) {
    var next = clone(state);
    var existing = next.items.find(function (line) {
      return String(line.variant_id || line.id) === String(item.variant_id || item.id);
    });
    if (existing) {
      existing.quantity += Number(item.quantity || 1);
      existing.final_line_price = Number(existing.final_price || existing.price || 0) * existing.quantity;
    } else {
      next.items.push(item);
    }
    next._pending = true;
    delete next.total_price;
    delete next.total_discount;
    delete next.items_subtotal_price;
    delete next.cart_level_discount_applications;
    return normaliseCart(next);
  }

  function queueMutation(optimisticCart, request, controls) {
    var previous = clone(state);
    var version = ++mutationVersion;
    renderAll(optimisticCart);
    controls = controls || [];
    controls.forEach(function (control) { control.disabled = true; });
    serverQueue = serverQueue.then(request).then(fetchCart).then(function (serverCart) {
      if (version === mutationVersion) renderAll(serverCart);
      controls.forEach(function (control) { control.disabled = false; });
      return serverCart;
    }).catch(function (error) {
      if (version === mutationVersion) renderAll(previous);
      controls.forEach(function (control) { control.disabled = false; });
      showCartError(error && error.message ? error.message : 'We could not update your bag. Please try again.');
      return fetchCart().then(function (serverCart) {
        if (version === mutationVersion) renderAll(serverCart);
      }).catch(function () {});
    });
    return serverQueue;
  }

  function showCartError(message) {
    var notice = document.getElementById('NurayaCartNotice');
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'NurayaCartNotice';
      notice.className = 'nl-cart-notice';
      notice.setAttribute('role', 'status');
      document.body.appendChild(notice);
    }
    notice.textContent = message;
    notice.classList.add('is-visible');
    window.setTimeout(function () { notice.classList.remove('is-visible'); }, 3500);
  }

  function changeQuantity(key, quantity, control) {
    quantity = Math.max(0, Number(quantity || 0));
    return queueMutation(optimisticChange(key, quantity), function () {
      return fetch(localePath('/cart/change.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (response) {
        if (!response.ok) throw new Error('We could not update that item.');
      });
    }, control ? [control] : []);
  }

  function productPageItem(form, variantId) {
    var variantsElement = document.getElementById('ProductVariantData');
    var variants = variantsElement ? JSON.parse(variantsElement.textContent || '[]') : [];
    var variant = variants.find(function (candidate) { return String(candidate.id) === String(variantId); }) || {};
    var title = document.querySelector('h1') ? document.querySelector('h1').textContent.trim() : document.title.split('—')[0].trim();
    var image = variant.featured_image && (variant.featured_image.src || variant.featured_image.url);
    if (!image) {
      var mainImage = document.getElementById('ProductMainImage') || document.querySelector('.product img');
      image = mainImage ? (mainImage.currentSrc || mainImage.src) : '';
    }
    var price = Number(variant.price || 0);
    return {
      key: 'pending-' + variantId,
      id: Number(variantId),
      variant_id: Number(variantId),
      product_id: Number(variant.product_id || 0),
      quantity: 1,
      product_title: title,
      variant_title: variant.public_title || variant.title || '',
      price: price,
      final_price: price,
      final_line_price: price,
      image: image,
      url: location.pathname + '?variant=' + variantId,
      handle: location.pathname.split('/products/')[1] || ''
    };
  }

  function curationItem(card, variantId) {
    var product = card._nurayaProduct || {};
    var variant = (product.variants || []).find(function (candidate) { return String(candidate.id) === String(variantId); }) || {};
    var image = variant.featured_image && (variant.featured_image.src || variant.featured_image.url);
    if (!image) image = card.querySelector('img') ? card.querySelector('img').src : '';
    var price = Number(variant.price || 0);
    return {
      key: 'pending-' + variantId,
      id: Number(variantId),
      variant_id: Number(variantId),
      product_id: Number(product.id || 0),
      quantity: 1,
      product_title: product.title || card.querySelector('.nl-precheckout__title').textContent,
      variant_title: variant.public_title || variant.title || '',
      price: price,
      final_price: price,
      final_line_price: price,
      image: image,
      url: '/products/' + product.handle + '?variant=' + variantId,
      handle: product.handle || ''
    };
  }

  function addItem(item, payload, button) {
    var optimistic = optimisticAdd(item);
    if (button) {
      button.dataset.originalText = button.dataset.originalText || button.textContent;
      button.textContent = cartArabic() ? 'تمت الإضافة إلى الحقيبة ✓' : 'ADDED TO BAG ✓';
      button.classList.add('is-added');
    }
    return queueMutation(optimistic, function () {
      return fetch(localePath('/cart/add.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: payload instanceof FormData ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: payload instanceof FormData ? payload : JSON.stringify(payload)
      }).then(function (response) {
        if (!response.ok) return response.json().catch(function () { return {}; }).then(function (data) {
          throw new Error(data.description || 'We could not add that selection.');
        });
      });
    }, button ? [button] : []).then(function () {
      if (!button) return;
      var present = state && state.items.some(function (line) {
        return String(line.variant_id || line.id) === String(item.variant_id || item.id);
      });
      button.textContent = present ? (cartArabic() ? 'في حقيبتك' : 'IN YOUR BAG') : (cartArabic() ? 'أضيفي إلى الحقيبة' : (button.dataset.originalText || 'ADD TO BAG'));
      button.classList.toggle('is-added', !!present);
    });
  }

  function handleProductSubmit(event, form) {
    event.preventDefault();
    event.stopImmediatePropagation();
    var formData = new FormData(form);
    var variantId = formData.get('id');
    var button = form.querySelector('[type="submit"]');
    if (!variantId || !button || button.disabled) return;
    addItem(productPageItem(form, variantId), formData, button);
  }

  function handleClick(event) {
    var open = event.target.closest('[data-cart-open]');
    if (open) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openDrawer();
      return;
    }
    if (event.target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }
    var remove = event.target.closest('[data-nl-cart-remove]');
    if (remove) {
      event.preventDefault();
      changeQuantity(remove.getAttribute('data-nl-cart-remove'), 0, remove);
      return;
    }
    var quantity = event.target.closest('[data-nl-cart-quantity]');
    if (quantity) {
      event.preventDefault();
      changeQuantity(quantity.getAttribute('data-nl-cart-quantity'), quantity.getAttribute('data-quantity'), quantity);
      return;
    }
    var curationButton = event.target.closest('[data-nl-curation-add]');
    if (curationButton) {
      event.preventDefault();
      var card = curationButton.closest('.nl-precheckout__card');
      var variantId = curationButton.getAttribute('data-variant-id');
      if (card && variantId && !curationButton.disabled) {
        addItem(curationItem(card, variantId), { items: [{ id: Number(variantId), quantity: 1 }] }, curationButton);
      }
    }
  }

  function handleChange(event) {
    var input = event.target.closest('[data-nl-cart-input]');
    if (input) {
      changeQuantity(input.getAttribute('data-nl-cart-input'), input.value, input);
      return;
    }
    var selector = event.target.closest('.nl-precheckout__option');
    if (selector) syncCurationCard(selector.closest('.nl-precheckout__card'));
  }

  function removeLegacyUi() {
    document.querySelectorAll('.brand-cart-upsell,#brand-cart-upsell-template,.nl-cart-loading').forEach(function (element) {
      element.remove();
    });
  }

  function liquidRecommendations() {
    var data = document.getElementById('nl-liquid-recommendations');
    if (!data) return [];
    try { var parsed = JSON.parse(data.textContent || '[]'); return Array.isArray(parsed) ? parsed : (parsed.entries || []); } catch (_) { return []; }
  }

  function availableVariants(product) {
    return (product.variants || []).filter(function (variant) { return variant.available; });
  }

  function variantImage(variant, fallback) {
    var image = variant && (variant.featured_image || variant.featured_media);
    if (image && typeof image === 'object') image = image.src || image.url || (image.preview_image && image.preview_image.src);
    return image || fallback || '';
  }

  function optionPrompt(name) {
    var lower = String(name || '').toLowerCase();
    if (/colou?r|shade/.test(lower)) return 'Choose your colour';
    if (/size|length/.test(lower)) return 'Choose your size';
    return 'Choose ' + String(name || 'option').toLowerCase();
  }

  function syncCurationCard(card) {
    if (!card || !card._nurayaProduct) return;
    var product = card._nurayaProduct;
    var variants = availableVariants(product);
    var selectors = Array.from(card.querySelectorAll('.nl-precheckout__option'));
    var selected = selectors.map(function (selector) { return selector.value; });
    selectors.forEach(function (selector, index) {
      Array.from(selector.options).forEach(function (option) {
        if (!option.value) return;
        option.disabled = !variants.some(function (variant) {
          if (variant.options[index] !== option.value) return false;
          return selected.every(function (value, otherIndex) {
            return !value || otherIndex === index || variant.options[otherIndex] === value;
          });
        });
      });
    });
    var exact = variants.find(function (variant) {
      return selected.length && selected.every(function (value, index) { return value && variant.options[index] === value; });
    });
    var preview = exact || variants.find(function (variant) {
      return selected.every(function (value, index) { return !value || variant.options[index] === value; });
    });
    var image = card.querySelector('img');
    var price = card.querySelector('.nl-precheckout__price');
    var button = card.querySelector('[data-nl-curation-add]');
    if (preview && image) setCurationImage(card, variantImage(preview, card._nurayaFallbackImage));
    if (preview && price) price.textContent = money(preview.price);
    if (!button) return;
    if (exact) {
      button.disabled = false;
      button.setAttribute('data-variant-id', exact.id);
      button.textContent = state && state.items.some(function (line) { return String(line.variant_id) === String(exact.id); }) ? 'IN YOUR BAG' : 'ADD TO BAG';
    } else {
      button.disabled = true;
      button.removeAttribute('data-variant-id');
      button.textContent = selectors.length ? 'CHOOSE YOUR OPTIONS' : 'ADD TO BAG';
    }
  }

  function curationCard(entry) {
    var product = entry.product || {};
    var variants = availableVariants(product);
    if (!entry.handle || !entry.title || !entry.image || !product.id || !variants.length) return null;
    var card = document.createElement('article');
    card.className = 'nl-precheckout__card';
    card._nurayaProduct = product;
    card._nurayaFallbackImage = entry.image;
    var names = (product.options || []).map(function (option, index) {
      return typeof option === 'string' ? option : (option.name || 'Option ' + (index + 1));
    });
    if (!names.length) names = ['Title'];
    var controls = names.map(function (name, index) {
      var values = Array.from(new Set(variants.map(function (variant) { return variant.options[index]; }).filter(Boolean)));
      if (String(name).toLowerCase() === 'title' && values.length === 1 && String(values[0]).toLowerCase() === 'default title') return '';
      return '<select class="nl-precheckout__option" data-option-index="' + index + '" aria-label="' + escapeHtml(optionPrompt(name)) + '">' +
        '<option value="">' + escapeHtml(optionPrompt(name)) + '</option>' +
        values.map(function (value) { return '<option value="' + escapeHtml(value) + '">' + escapeHtml(value) + '</option>'; }).join('') +
      '</select>';
    }).join('');
    var first = variants[0];
    card.innerHTML = '<a class="nl-precheckout__image" href="/products/' + escapeHtml(entry.handle) + '"><img src="' + escapeHtml(variantImage(first, entry.image)) + '" alt="' + escapeHtml(entry.title) + '" loading="eager" width="700" height="933"></a>' +
      '<p class="nl-precheckout__title">' + escapeHtml(entry.title) + '</p>' +
      '<p class="nl-precheckout__price">' + money(first.price) + '</p>' +
      '<div class="nl-precheckout__options">' + controls + '</div>' +
      '<button class="nl-precheckout__add" type="button" data-nl-curation-add disabled>CHOOSE YOUR OPTIONS</button>';
    setCurationImage(card, entry.image);
    if (!controls) {
      var button = card.querySelector('[data-nl-curation-add]');
      button.disabled = false;
      button.setAttribute('data-variant-id', first.id);
      button.textContent = 'ADD TO BAG';
    }
    return card;
  }

  var curationPoolPromise;
  function fullCurationPool() {
    if (curationPoolPromise) return curationPoolPromise;
    var seed = document.getElementById('nl-liquid-recommendations');
    var metadata = {};
    try { metadata = JSON.parse(seed ? seed.textContent : '{}'); } catch (_) {}
    var entries = liquidRecommendations().slice();
    var pages = Number(metadata.pages || 1);
    var current = Number(metadata.page || 1);
    var sequence = Promise.resolve();
    for (var page = 1; page <= pages; page++) {
      if (page === current) continue;
      (function (number) {
        sequence = sequence.then(function () {
          var url = new URL(location.href);
          url.searchParams.set('page', number);
          return fetch(url.pathname + url.search, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
            .then(function (response) { if (!response.ok) throw new Error('Catalogue unavailable'); return response.text(); })
            .then(function (html) {
              var node = new DOMParser().parseFromString(html, 'text/html').getElementById('nl-liquid-recommendations');
              var data = JSON.parse(node ? node.textContent : '{}');
              entries = entries.concat(data.entries || []);
            });
        });
      })(page);
    }
    curationPoolPromise = sequence.catch(function () {}).then(function () {
      var seen = new Set();
      return entries.filter(function (entry) { if (seen.has(entry.handle)) return false; seen.add(entry.handle); return true; });
    });
    return curationPoolPromise;
  }

  function curationImageSources(product, preferred, fallback) {
    return Array.from(new Set([preferred, fallback, product.featured_image].concat(product.images || []).map(function (image) {
      if (image && typeof image === 'object') image = image.src || image.url || (image.preview_image && image.preview_image.src);
      if (typeof image !== 'string' || !image) return '';
      return image.indexOf('//') === 0 ? 'https:' + image : image;
    }).filter(Boolean)));
  }

  function setCurationImage(card, preferred) {
    var image = card.querySelector('img');
    if (!image) return;
    var sources = curationImageSources(card._nurayaProduct, preferred, card._nurayaFallbackImage);
    var index = 0;
    image.onerror = function () {
      index++;
      if (index < sources.length) image.src = sources[index];
      else { image.onerror = null; card.hidden = true; card.style.setProperty('display', 'none', 'important'); }
    };
    if (sources.length && image.getAttribute('src') !== sources[0]) image.src = sources[0];
  }

  function usableCurationImage(entry) {
    var sources = curationImageSources(entry.product, entry.image, '');
    return new Promise(function (resolve) {
      function next(index) {
        if (index >= sources.length) { resolve(null); return; }
        var image = new Image();
        image.onload = function () { entry.image = sources[index]; resolve(entry); };
        image.onerror = function () { next(index + 1); };
        image.src = sources[index];
      }
      next(0);
    });
  }

  function renderCuration() {
    var root = document.querySelector(SELECTORS.curation);
    var grid = document.querySelector(SELECTORS.curationGrid);
    if (!root || !grid) return;
    return fullCurationPool().then(function (pool) {
      var inBag = new Set((state ? state.items : []).map(function (item) { return String(item.product_id); }));
      var recent = [];
      try { recent = JSON.parse(sessionStorage.getItem('nuraya-curation-recent') || '[]'); } catch (_) {}
      var ranked = pool.filter(function (entry) {
        var product = entry.product || {};
        return entry.handle && entry.title && entry.image && product.id && !inBag.has(String(product.id)) && availableVariants(product).length;
      }).map(function (entry) {
        var weight = Math.max(1, Number(entry.weight || 1));
        if (recent.indexOf(entry.handle) >= 0) weight *= 0.15;
        return { entry: entry, score: -Math.log(Math.max(Number.EPSILON, Math.random())) / weight };
      }).sort(function (a, b) { return a.score - b.score; });
      var chosen = [];
      function fill() {
        if (chosen.length >= 6 || !ranked.length) return Promise.resolve();
        var batch = ranked.splice(0, 6 - chosen.length);
        return Promise.all(batch.map(function (candidate) { return usableCurationImage(candidate.entry); })).then(function (results) {
          chosen = chosen.concat(results.filter(Boolean));
          return fill();
        });
      }
      return fill().then(function () {
        var fragment = document.createDocumentFragment();
        chosen.forEach(function (entry) { var card = curationCard(entry); if (card) fragment.appendChild(card); });
        grid.replaceChildren(fragment);
        grid.classList.add('nl-options-ready');
        try { sessionStorage.setItem('nuraya-curation-recent', JSON.stringify(chosen.map(function (entry) { return entry.handle; }).concat(recent).slice(0, 24))); } catch (_) {}
        var status = document.getElementById('nl-precheckout-status');
        if (status) status.hidden = true;
      });
    });
  }

  function updateCurationButtons() {
    document.querySelectorAll('[data-nl-curation-add][data-variant-id]').forEach(function (button) {
      var inBag = state && state.items.some(function (item) {
        return String(item.variant_id) === String(button.getAttribute('data-variant-id'));
      });
      button.textContent = inBag ? 'IN YOUR BAG' : 'ADD TO BAG';
      button.classList.toggle('is-added', !!inBag);
    });
  }

  function setupProductVariants() {
    var data = document.getElementById('ProductVariantData');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent || '[]'); } catch (_) { return; }
    var groups = Array.from(document.querySelectorAll('.product__option-values'));
    var idInput = document.getElementById('ProductSelectedVariantId');
    var price = document.getElementById('ProductPriceCurrent');
    var compare = document.getElementById('ProductPriceCompare');
    var button = document.getElementById('ProductAddToCart');
    var image = document.getElementById('ProductMainImage');
    var requestedId = new URLSearchParams(window.location.search).get('variant');
    var requestedVariant = variants.find(function (candidate) { return String(candidate.id) === requestedId; });
    if (requestedVariant) {
      groups.forEach(function (group, index) {
        group.querySelectorAll('.product__option-value').forEach(function (option) {
          option.classList.toggle('is-selected', option.getAttribute('data-value') === requestedVariant.options[index]);
        });
      });
    }
    function sync() {
      var selected = groups.map(function (group) {
        var active = group.querySelector('.product__option-value.is-selected');
        return active ? active.getAttribute('data-value') : null;
      });
      var variant = variants.find(function (candidate) {
        return selected.every(function (value, index) { return value === null || candidate.options[index] === value; });
      });
      if (!variant) {
        if (button) { button.disabled = true; button.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (compare) {
        compare.hidden = !(variant.compare_at_price && variant.compare_at_price > variant.price);
        if (!compare.hidden) compare.textContent = money(variant.compare_at_price);
      }
      if (button) { button.disabled = !variant.available; button.textContent = variant.available ? (cartArabic() ? 'أضيفي إلى الحقيبة' : 'Add to Bag') : (cartArabic() ? 'نفدت الكمية' : 'Sold Out'); button.classList.remove('is-added'); }
      var source = variantImage(variant);
      if (source && image) image.src = source;
    }
    document.addEventListener('click', function (event) {
      var option = event.target.closest('.product__option-value');
      if (!option) return;
      var group = option.closest('.product__option-values');
      group.querySelectorAll('.product__option-value').forEach(function (candidate) { candidate.classList.remove('is-selected'); });
      option.classList.add('is-selected');
      sync();
    });
    sync();
  }

  function setupGalleryAndNavigation() {
    var mainImage = document.getElementById('ProductMainImage');
    document.addEventListener('click', function (event) {
      var thumbnail = event.target.closest('.product__thumbnail');
      if (thumbnail && mainImage) {
        mainImage.src = thumbnail.getAttribute('data-media-src');
        document.querySelectorAll('.product__thumbnail').forEach(function (candidate) { candidate.classList.remove('is-active'); });
        thumbnail.classList.add('is-active');
      }
      var menu = event.target.closest('[data-menu-toggle]');
      if (menu) {
        var nav = document.querySelector('[data-nav]');
        if (nav) nav.classList.toggle('is-open');
      }
    });
    var top = document.getElementById('BackToTop');
    if (top) {
      var toggle = function () { top.classList.toggle('is-visible', window.scrollY > 480); };
      window.addEventListener('scroll', toggle, { passive: true });
      top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
      toggle();
    }
  }

  function startVideos() {
    document.querySelectorAll('video.hero__media,video[autoplay]').forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'auto');
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function () {});
    });
  }

  function installStyles() {
    var style = document.createElement('style');
    style.id = 'nuraya-stable-commerce-styles';
    style.textContent =
      '#CartDrawer .cart-drawer__body{padding:8px 24px 24px;box-sizing:border-box}#CartDrawer .cart-drawer__header{padding-left:24px;padding-right:24px}' +
      '.nl-cart-item{display:grid;grid-template-columns:78px minmax(0,1fr);gap:14px;padding:16px 0;border-bottom:1px solid rgba(24,20,15,.12)}' +
      '.nl-cart-item__image{width:78px;height:98px;overflow:hidden}.nl-cart-item__image img{width:78px;height:98px;object-fit:cover;display:block}' +
      '.nl-cart-item__top,.nl-cart-item__bottom,.nl-cart-summary>div{display:flex;justify-content:space-between;gap:12px;align-items:center}' +
      '.nl-cart-item__title{color:inherit;text-decoration:none}.nl-cart-item__variant{font-size:12px;opacity:.65;margin-top:4px}' +
      '.nl-cart-item__remove{border:0;background:none;font-size:20px;cursor:pointer;padding:0 3px}.nl-cart-item__bottom{margin-top:12px}' +
      '.nl-cart-quantity{display:inline-flex;border:1px solid rgba(24,20,15,.25)}.nl-cart-quantity button{width:34px;height:32px;border:0;background:none;cursor:pointer}.nl-cart-quantity span{min-width:30px;text-align:center;line-height:32px}' +
      '.nl-cart-summary{padding:20px 0 4px}.nl-cart-summary .btn{display:block;text-align:center;width:100%;box-sizing:border-box;margin-top:16px}' +
      '.nl-cart-empty{padding:32px 0;text-align:center}.nl-cart-notice{position:fixed;left:50%;bottom:24px;transform:translate(-50%,20px);opacity:0;pointer-events:none;background:#18140f;color:#fff;padding:12px 18px;z-index:99999;transition:.2s}.nl-cart-notice.is-visible{opacity:1;transform:translate(-50%,0)}' +
      '.nl-precheckout__status{display:none!important}.nl-precheckout__grid{visibility:visible!important;animation:none!important;display:grid!important;grid-template-columns:repeat(6,minmax(0,1fr))!important;gap:16px!important;align-items:stretch!important}' +
      '.nl-product-upsell{max-width:1440px!important;margin:76px auto 94px!important;padding:0 32px!important}.nl-product-upsell__eyebrow{font-size:10px!important;letter-spacing:.28em!important;color:#a17d47!important;margin-bottom:12px!important}.nl-product-upsell h2{font-family:"Cormorant Garamond",Georgia,serif!important;font-size:clamp(34px,3.4vw,52px)!important;line-height:1.08!important;letter-spacing:-.018em!important;margin-bottom:38px!important}.nl-product-upsell__grid{gap:20px!important}.nl-product-upsell__image{aspect-ratio:3/4!important;background:#f3eee5!important}.nl-product-upsell__card h3{font-family:"Cormorant Garamond",Georgia,serif!important;font-size:16px!important;line-height:1.35!important;margin:14px 0 5px!important}.nl-product-upsell__card p{font-size:12px!important}' +
      '.nl-precheckout__card{display:flex!important;flex-direction:column!important;min-width:0;height:100%!important}.nl-precheckout__image{display:block!important;aspect-ratio:3/4!important;overflow:hidden!important}.nl-precheckout__image img{width:100%!important;height:100%!important;object-fit:cover!important;display:block!important}' +
      '.nl-precheckout__title{min-height:3em!important;margin:12px 0 8px!important}.nl-precheckout__price{margin:0 0 12px!important}.nl-precheckout__options{display:grid!important;gap:8px!important;margin-top:auto!important}' +
      '.nl-precheckout__option{width:100%!important;min-height:48px!important;padding:0 12px!important;background:#fff!important;border:1px solid rgba(24,20,15,.22)!important;color:#18140f!important}.nl-precheckout__add{width:100%!important;min-height:50px!important;margin-top:10px!important}' +
      '@media(max-width:990px){.nl-precheckout__grid{grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:18px!important}}' +
      '@media(max-width:640px){#CartDrawer .cart-drawer__header{padding-left:18px!important;padding-right:18px!important}#CartDrawer .cart-drawer__body{padding:6px 18px 22px!important}.nl-cart-item{grid-template-columns:72px minmax(0,1fr);gap:12px}.nl-cart-item__image,.nl-cart-item__image img{width:72px;height:90px}.nl-precheckout__grid{grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:20px 12px!important}.nl-precheckout__title{min-height:0!important}.nl-precheckout__option,.nl-precheckout__add{min-height:48px!important}.nl-product-upsell{margin:58px auto 76px!important;padding:0!important}.nl-product-upsell__eyebrow,.nl-product-upsell h2{padding-left:20px!important;padding-right:20px!important}.nl-product-upsell h2{font-size:34px!important;margin-bottom:28px!important}.nl-product-upsell__grid{display:flex!important;gap:14px!important;overflow-x:auto!important;scroll-snap-type:x mandatory!important;padding:0 20px 12px!important;scrollbar-width:none!important;-webkit-overflow-scrolling:touch!important}.nl-product-upsell__grid::-webkit-scrollbar{display:none}.nl-product-upsell__card{flex:0 0 68%!important;max-width:260px!important;scroll-snap-align:start!important}.nl-product-upsell__card h3{font-size:15px!important;margin-top:12px!important}}';
    document.head.appendChild(style);
  }

  function initialise() {
    installStyles();
    removeLegacyUi();
    setupProductVariants();
    setupGalleryAndNavigation();
    startVideos();
    document.addEventListener('click', handleClick, true);
    document.addEventListener('change', handleChange, true);
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (form && form.matches && form.matches(SELECTORS.productForm)) handleProductSubmit(event, form);
    }, true);
    var immediate = initialCart() || normaliseCart({ items: [], currency: activeCurrency() });
    renderAll(immediate);
    fetchCart().then(function (cart) { renderAll(cart); return renderCuration(); }).catch(function () { renderCuration(); });
  }

  window.NurayaTheme = {
    getCart: function () { return clone(state); },
    refresh: function () { return fetchCart().then(renderAll); },
    openCart: openDrawer
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  window.addEventListener('pageshow', function (event) { if (event.persisted) window.NurayaTheme.refresh(); });
})();
